// Bus.js
import Vue from 'vue'
import moment from 'moment'

export default new Vue({
  data: {
    sideWideAnnouncement: false,
    now: moment().utc(),
    loadingEvents: false,
    toast: {/* text: 'eksample text', 'success': false */},
    createModalOpen: false,
    showOnboardingArrow: false,
    showSetupWidget: false,
    createUserModal: false,
    createUserModalROR: false,
    createKlassModal: false,
    createRoomModal: false,
    createMergeModal: false,
    editCalendarNameModal: false,
    editCalendarDeleteModal: false,
    createdId: null,
    isOpenYouTubePopup: false,
    youTubeVideoId: '',
    copyEventEvent: null,
    copyEventsBulk: null,
    isLessonNoteChangedWithoutSaving: false,
    activeChangeRoleId: null,
    calendars: [],
    createCalendarsType: null,
    isPrintCalendarsModal: false,
    printCalendarType: null,
    theKlassesToImportSubjectTo: []
  }
  // methods
  // watch
})



// WEBPACK FOOTER //
// ./src/eventbus.js